import React from 'react';
import { Nav } from '../components/Nav';
import { Hero } from '../components/Hero';
import { LogoWall } from '../components/LogoWall';
import { Practice } from '../components/Practice';
import { Ventures } from '../components/Ventures';
import { Approach } from '../components/Approach';
import { Contact } from '../components/Contact';
import { Footer } from '../components/Footer';
interface HomeProps {
  showApproach: boolean;
}
export function Home({
  showApproach
}: HomeProps) {
  return <div className="min-h-full w-full bg-paper" data-id="element-131" data-mp="24gsg0eyt680d">
      <Nav data-id="element-132" data-mp="24hahpr48pefo" />
      <main data-id="element-133" data-mp="24j4taetmfu73">
        <Hero data-id="element-134" data-mp="24iv9xa330lad" />
        <LogoWall data-id="element-135" data-mp="29gdb2eauxw7t" />
        <Practice data-id="element-136" data-mp="29fvgdm3ufq20" />
        <Ventures data-id="element-137" data-mp="29fbww0yjotlv" />
        {showApproach ? <Approach data-id="element-138" data-mp="29ihnxlqqi5k8" /> : null}
        <Contact data-id="element-139" data-mp="2di8d5l0m4dmn" />
      </main>
      <Footer data-id="element-140" data-mp="2dii2d6du2gra" />
    </div>;
}